import { LanguageService } from './../../../Services/languageService';
import { Subscription } from 'rxjs';
import { userService } from './../../../Services/userService';
import { TPLProposal } from './../../../Models/TPLProposal';
import { PayfortTransInfoModel } from './../../../Models/ProposalModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component, ViewChild, ElementRef, Renderer } from '@angular/core';
import { RenewBindMdl } from '../../../Models/RenewBindMdl';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';
import { ProposalRes } from '../../../Models/ProposalRes';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;
//import swal from 'sweetalert';
import { TransInfoModel } from '../../../Models/ProposalModel';
import { MotorproposalTrackingService } from '../../../Services/MotorproposalTrackingService';
import { renewalProposalService } from '../../../Services/renewalProposalService';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
declare let $: any;
@Component({
  selector: 'RenewalReviewConfirm',
  templateUrl: './RenewalReviewConfirm.html',
  styleUrls: ['./RenewalReviewConfirm.css']
})
export class RenewalReviewConfirm {
  public prObj: TPLProposal = new TPLProposal();
  public IBAN1: string;
  public IBAN2: string;
  public IBAN3: string;
  public IBAN4: string;
  public IBAN5: string;
  public IBAN6: string;

  public bindObj: RenewBindMdl = new RenewBindMdl();
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public prResObj: ProposalRes = new ProposalRes();
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public Lng: string;
  public ShowHigherPositionFeild: boolean = false;
  public isSubmitted: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  @ViewChild('txtIBAN2') txtIBAN2Element: ElementRef;
  @ViewChild('txtIBAN3') txtIBAN3Element: ElementRef;
  @ViewChild('txtIBAN4') txtIBAN4Element: ElementRef;
  @ViewChild('txtIBAN5') txtIBAN5Element: ElementRef;
  @ViewChild('txtIBAN6') txtIBAN6Element: ElementRef;


  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private renderer: Renderer, private trackingObj: MotorproposalTrackingService, private userinfo: userService, private lngService: LanguageService) {

    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });
    this.bindObj = this.proposalService.getRenewalBindObj();
    this.prObj = this.proposalService.getRenewalProposalObj();

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }

  }
  goPrev() {
    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.saveRenewalBindObj(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "RenewalVehicleDetails");
    this.router.navigate(['NewDashboard/RenewalProposal/RenewalVehicleDetails']);
  }

  goNext() {
    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.saveRenewalBindObj(this.bindObj);
    this.saveProposal();
  }
  setBankCode(IBAN) {
    let bankCode: string = IBAN.substring(0, 2)
    this.prObj.BankCode = bankCode;
    if (IBAN != "" && IBAN != undefined && IBAN != null) {
      if (IBAN.length == 4) {
        let bankCode: string = IBAN.substring(0, 2)
        this.prObj.BankCode = bankCode;
        if (this.bindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }
      }
    }
  }

  checkalert(ReviewConfirmForm) {
    this.isSubmitted = true;
    if (this.prObj.IsHigherPosition == undefined) {
      swal("Please select Is Higher Position");
      return;
    }
    if (this.prObj.IsHigherPosition == true && this.prObj.HigherPositionCode == undefined) {
      this.prObj.HigherPositionCode = 0;
      return;
    } else if (this.prObj.IsHigherPosition == false) {
      this.prObj.HigherPositionCode = 0;
      this.saveProposal();
    } else if (this.prObj.IsHigherPosition == true && this.prObj.HigherPositionCode != undefined) {
      this.prObj.HigherPositionCode = Number(this.prObj.HigherPositionCode);
      if (ReviewConfirmForm.valid) {
        this.saveProposal();
      }
    }
  }

  IsHigherPosition(val) {
    if (val == "true") {
      this.prObj.IsHigherPosition = true;
      this.ShowHigherPositionFeild = true;
    } else {
      this.prObj.IsHigherPosition = false;
      this.ShowHigherPositionFeild = false;
    }
  }
  saveProposal() {
    if (this.prObj.IBAN1 != null && this.prObj.IBAN2 != null && this.prObj.IBAN3 != null && this.prObj.IBAN4 != null && this.prObj.IBAN5 != null && this.prObj.IBAN6 != null) {
      this.prObj.IBAN = this.prObj.IBAN1 + this.prObj.IBAN2 + this.prObj.IBAN3 + this.prObj.IBAN4 + this.prObj.IBAN5 + this.prObj.IBAN6;
    }
    this.prObj.IBAN = "SA" + this.prObj.IBAN;
    let regNo: string = sessionStorage.getItem("RegNo");
    if (this.prObj.IBAN != null) {
      if (this.prObj.IBAN.length != 24) {
        this.Lng == "ar" ? swal(" رقم الايبان 24 رقم فقط ") : swal("IBAN Number must be 24 digits");
        return;
      }
      else if ((this.prObj.BankCode.length == 0 || this.prObj.BankCode == null || this.prObj.BankCode == "00")) {
        this.Lng == "ar" ? swal("اسم البنك غير صحيح ") : swal("Invalid Bank Name");
        return;

      }
    }


    this.prObj.RegNo = regNo;
    if (this.prObj.IBAN != null) {
      if (this.prObj.IBAN.length != 24) {
        swal("IBAN Number must be 24 digits");
      }
      else {
        if (this.bindObj.bankList.filter(t => t.BankCode == this.prObj.BankCode).length > 0) {
          let title: string;
          let PopupHeader: string = "Certify And Confirm";
          title = "I certify and confirm that all the information furnished/provided by me in/with this application form is true, full & complete to best of my knowledge & belief";
          if (this.Lng == "ar") {
            title = "أقر أن جميع المعلومات التي عرضت / قدمت في هذا الطلب هي معلومات صحيحة وكاملة . وبعلم وإيقان كامل من طرفي";
            PopupHeader = "تأكيد البيانات";
          }

          swal({ title: title, text: "", icon: "warning", buttons: [true, true] }).then((result) => {
            if (result) {
              // this.saveProposal();

              this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

              this.isShowLoading = true;
              //this.http.post<PayfortTransInfoModel>(this.url.baseURL + "/RenewPolicy/saveRenewalProposal", this.prObj, this.userinfo.getHttpOptions()).
              this.http.post<mdlPayloadResponse>(this.url.baseURL + "/RenewPolicy/saveRenewalProposal", this.objPayloadRequest, this.userinfo.getHttpOptions()).
                toPromise().then((res) => {
                  //this.transObj = res;
                  //New Line Start
                  this.objPayloadResponse = res;
                  this.transObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                  //NewLine End

                  swal(this.transObj.st.StatusDesc);
                  if (this.transObj.st.StatusCode === "S") {
                    sessionStorage.setItem("NavFrom", "PR");
                    //sessionStorage.setItem("transObj", JSON.stringify(this.transObj));
                    sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
                    sessionStorage.setItem("CurrentRoute", "PayfortPayment");
                    this.router.navigate(['/NewDashboard/PayfortPayment']);
                  }
                  this.isShowLoading = false;
                },
                  (error) => {

                    this.isShowLoading = false;
                    this.userinfo.checkTokenStatus(error);
                  }
                )
            }

          });

        } else {
          swal("Invalid BankCode", "Please enter Valid Bank Code.", "error")
        }


      }
    }
    else {
      alert("Please Enter IBAN Number to proceed");
    }
  }

  iban1Changed(event) {

    if (event != "" && event != undefined && event != null) {
      if (event.length == 2) {
      
        setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
      }
    }
  }

  iban2Changed(event) {
    if (event != "" && event != undefined && event != null) {
      //alert(event.length);
      if (event.length == 4) {
        let bankCode: string = event.substring(0, 2)
        this.prObj.BankCode = bankCode;
        if (this.bindObj.bankList.filter(t => t.BankCode == bankCode).length > 0) {
          setTimeout(() => this.txtIBAN3Element.nativeElement.focus(), 0);
        }
        else {
          setTimeout(() => this.txtIBAN2Element.nativeElement.focus(), 0);
        }


      }
    }
  }


  iban3Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN4Element.nativeElement.focus(), 0);
      }
    }
  }

  iban4Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN5Element.nativeElement.focus(), 0);
      }
    }
  }

  iban5Changed(event) {
    if (event != "" && event != undefined && event != null) {
      if (event.length == 4) {
        setTimeout(() => this.txtIBAN6Element.nativeElement.focus(), 0);
      }
    }
  }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalReviewConfirm/RenewalReviewConfirm.ts